import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFeedResumeStore } from "@/common/store/feedResumeStore";
import { getFeedPath, getFeedSection } from "@/common/utils/feedResume";

export const useTrackFeedVisits = () => {
  const { pathname, search, key } = useLocation();
  const setVisit = useFeedResumeStore((state) => state.setVisit);

  useEffect(() => {
    const section = getFeedSection(pathname);

    if (section === null) {
      return;
    }

    setVisit(section, { path: getFeedPath(pathname, search), locationKey: key });
  }, [pathname, search, key, setVisit]);
};
